import Vue from 'vue';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';

const data = {
  customerId: null,
  customerName: '',
  isCustomerRegistered: false,
  customerAccounts: [],
};
const mutations = {
  SET_CUSTOMER(state, {
    id, username, isRegistered, accounts,
  }) {
    state.customerId = id || state.customerId;
    state.isCustomerRegistered = isRegistered || state.isCustomerRegistered;
    state.customerName = username || state.customerName;
    Vue.set(state, 'customerAccounts', accounts || state.customerAccounts);
  },
  RESET_CUSTOMER(state) {
    state.customerId = null;
    state.customerName = '';
    state.isCustomerRegistered = false;
    Vue.set(state, 'customerAccounts', []);
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
};

export default store;
